<template>
    <div :class="[isDisabledChannel(channel) && 'disabled', 'col-md-4 col-sm-6']" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
        <div class="grid__view" v-tooltip="isDisabledChannel(channel) ? {content: $t('paragraphs.channel.not_available_desc'), classes: ['tooltip--long'], html:true, placement: 'bottom', boundariesElement: 'window', show: showTooltip, trigger: 'manual'} : false">
            <div class="grid__header">
                <img :src="getIdleScreenUrl(channel.idle_screen_url)" :key="channel.id" data-holder-rendered="true" @mouseover="channel.showDetail = true" @mouseleave="channel.showDetail = false" class="grid__thumbnail">
                <div class="form-checkbox">
                    <input type="checkbox" :id="`channel_${ channel.id}`" name="chk_channel" :value="channel.id" :checked="false" v-model="channel.selected" />
                    <label :for="`channel_${ channel.id }`"></label>
                </div>
                <span class="badge badge__live badge__grid" v-if="isOnAirByChannel(channel)">{{ $t('words.live_onair') }}</span>
                <div class="grid__overlay">
                    <div class="grid__live__empty" v-if="typeof channel.latest_live_media_broadcast.paused_at === 'undefined'">{{ $t('paragraphs.channel.latest_broadcast_list_empty') }}</div>
                    <table class="table" v-else>
                        <tbody>
                        <tr>
                            <td class="thead">{{ $t('words.started_at') }}</td>
                            <td><span v-if="channel.latest_live_media_broadcast.started_at">{{ renderDatetime(channel.latest_live_media_broadcast.started_at) }}</span></td>
                        </tr>
                        <tr>
                            <td class="thead">{{ $t('words.ended_at') }}</td>
                            <td><span v-if="channel.latest_live_media_broadcast.paused_at">{{ renderDatetime(channel.latest_live_media_broadcast.paused_at) }}</span></td>
                        </tr>
                        <tr>
                            <td class="thead">{{ $t('words.broadcast_interval') }}</td>
                            <td>{{ channel.latest_live_media_broadcast.interval }}</td>
                        </tr>
                        <!--<tr>-->
                            <!--<td class="thead">{{ $t('words.accumulate_viewers') }}</td>-->
                            <!--<td><span v-if="channel.latest_live_media_broadcast.sum_user">{{ channel.latest_live_media_broadcast.sum_user }}</span></td>-->
                        <!--</tr>-->
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="grid__body">
                <h5 class="grid__title"><i :class="{icon: true, '': channel.is_shared, 'icon-lock': !channel.is_shared}"></i><router-link :to="{ name: 'cms-channels-view', params: { channel_id: channel.id } }">{{ channel.title }}{{ isDisabledChannel(channel) ?  `(${$t('words.channel_not_available')})` : '' }}</router-link></h5>
                <span class="grid__creator">{{ channel.latest_live_media_broadcast.live_creator?channel.latest_live_media_broadcast.live_creator.nickname:'' }}</span>
                <span class="grid__viewer" v-if="showStats(channel)">{{ $t('words.accumulate_viewers') }}<span class="grid__viewer__count">{{ channel.latest_live_media_broadcast.sum_user }}</span></span>
                <!-- 아이콘 및 css속성 변경 예정 -->
                <a @click="showChannelCloningModal(channel)" class="btn btn-icon grid__action" style="right: 70px;">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="ic ic-copy">
                        <path d="M10 6H2V14H10V6Z" stroke="currentcolor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
                        <path d="M6 2H14V10" stroke="currentcolor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
                    </svg>
                </a>
                <router-link class="btn btn-icon grid__action" :to="{ name:'cms-channels-edit', params: { channel_id: channel.id } }"><i class="icon icon-edit"></i></router-link>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';
import DateTimeMixin from '../../mixin/DateTimeMixin';
import ChannelConfig from './ChannelConfig';

export default {
    name: 'ListCardItem',

    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],

    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            showTooltip: false,
        };
    },

    methods: {
        showStats(channel) {
            return channel.getStats && (typeof channel.latest_live_media_broadcast.sum_user !== 'undefined');
        },
        showChannelCloningModal(channel) {
            this.initChannelToClone();
            this.channelToClone.title = `${channel.title}_copy`;
            this.channelToClone.id = channel.id;
            $('#channelCloningModal').modal();
        },
        isOnAirByChannel(channel) {
            return typeof channel.latest_live_media_broadcast.is_onair === 'boolean' &&
                channel.latest_live_media_broadcast.is_onair;
        },
        isFileLiveChannel(channel) {
            return parseInt(channel.kind, 10) === ChannelConfig.CHANNEL_KIND.PROGRAMMING;
        },
        isWebRtcChannel(channel) {
            return parseInt(channel.kind, 10) === ChannelConfig.CHANNEL_KIND.WEBRTC;
        },
        isCmafChannel(channel) {
            return parseInt(channel.kind, 10) === ChannelConfig.CHANNEL_KIND.CMAF;
        },
        isDisabledChannel(channel) {
            const isDisabledProgrammingChannel = !this.useFileToLive && channel.kind === 1;
            const isDisabledCmafChannel = !this.useCmaf && channel.kind === 3;
            return isDisabledProgrammingChannel || isDisabledCmafChannel;
        },
        handleMouseEnter(e) {
            this.showTooltip = true;
        },
        handleMouseLeave(e) {
            this.showTooltip = false;
        },
        getIdleScreenUrl(url) {
            return `${url}?_bust=${this.randomInt}`;
        },
    },
};
</script>
